import styled from 'styled-components';
import { ifProp } from 'styled-tools';

const CellWrapper = styled.div`
  position: relative;
`;

const CellContent = styled.div`
  height: 1.5rem;
  display: flex;
  align-items: center;
  position: relative;
  cursor: text;
  border-radius: 0;
  background: #fff;
`;

const CheckboxHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
`;

const CheckboxRegularWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 1.5rem;
  position: relative;
  cursor: pointer;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  border-left: 1px solid #bdbdbd;
  border-right: 1px solid #bdbdbd;
  box-sizing: border-box;
`;

const Hint = styled.span`
  margin-left: 8px;
  font-size: 0.85em;
  color: #888;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 2px 6px;
  white-space: nowrap;
  position: absolute;
  left: 110%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 222;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;

const IncorrectCell = styled.div`
  height: 1.5rem;
  display: flex;
  align-items: center;
  position: relative;
  cursor: text;
  box-sizing: border-box;
  border-radius: 0;
  background-color: #fef2f2;
  border-right: 1px solid #fca5a5;
  border-bottom: 1px solid #fca5a5;
  border-left: ${ifProp('left', '1px solid #fca5a5', 'none')};
`;

const CellWithoutDataContent = styled.div`
  height: 1.5rem;
  display: flex;
  align-items: center;
  position: relative;
  cursor: text;
  box-sizing: border-box;
  border-radius: 0;
  background-color:rgb(240, 240, 240);
  border-right: ${ifProp('isMissing', '1px solid #fca5a5', '1px solid rgb(160, 160, 160)')};
  border-bottom:${ifProp('isMissing', '1px solid #fca5a5', '1px solid rgb(160, 160, 160)')};
  border-left: ${ifProp('left', '1px solid rgb(160, 160, 160);', 'none')};
  background-color: ${ifProp('isMissing', '#fef2f2', 'rgb(240, 240, 240)')};
`;

const EllipsisText = styled.div`
  height: 1.5rem;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  font-size: 1rem;
  padding: 0 0.25rem;
  font-family: inherit;
  font-weight: 400;
  color: var(--color-secondary-text);
  text-overflow: ellipsis;
  white-space: nowrap;
  border: ${ifProp('isSelected', '1px solid #ef4444', 'none')};
  border-right: ${ifProp('isSelected', '2px solid rgb(0, 119, 255)', '1px solid #bdbdbd')};
  border-bottom: ${ifProp('isSelected', '2px solid rgb(0, 119, 255)', '1px solid #bdbdbd')};
  border-left:  ${ifProp('isSelected', '2px solid rgb(0, 119, 255)', 'none')};
  border-top:  ${ifProp('isSelected', '2px solid rgb(0, 119, 255)', 'none')};
  box-sizing: border-box;
`;

const StyledCheckbox = styled.input`
  accent-color: var(--color-primary);
  
  &:checked {
    background-color: var(--color-primary);
    border-color: var(--color-primary);
  }
  
  &:checked::before {
    color: white;
  }
`;

const EditIconWrapper = styled.div`
  position: absolute;
  right: 0.25rem;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;

  ${CellWrapper}:hover & {
    opacity: 1;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  min-width: 0;
  height: 1.5rem;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-family: inherit;
  font-weight: 400;
  color: var(--color-secondary-text);
  background: #fff;
  border: none;
  box-sizing: border-box;
  border-radius: 0;
  box-shadow: none;
  outline: none;
  transition: border-color 0.2s;
  &:focus {
    border: 2px solid rgb(0, 119, 255);
  }
  &::placeholder {
    color: #bdbdbd;
  }
  &:disabled {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
    background: #f3f3f3;
  }

  &[aria-invalid="true"] {
    border-color: #a6031f;
    box-shadow: 0 0 0 2px #ffd6d6;
  }
`;

export {
  CellWrapper,
  CellContent,
  CheckboxHeaderWrapper,
  CheckboxRegularWrapper,
  Hint,
  CellWithoutDataContent,
  EllipsisText,
  EditIconWrapper,
  StyledInput,
  StyledCheckbox
};
